import { Component, inject } from '@angular/core';
import { DATE_OPTIONS, MartketplaceTransferredItem, RewardsWalletQuery, RewardsWalletService } from '@fgb/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'fgbcl-wallet-transferred-list',
  templateUrl: './wallet-transferred-list.component.html',
  styleUrl: './wallet-transferred-list.component.scss',
})
export class WalletTransferredListComponent {
  private rewardsWalletQuery = inject(RewardsWalletQuery);
  private rewardsWalletService = inject(RewardsWalletService);
  private modalService = inject(NgbModal);
  transferredItems$ = this.rewardsWalletQuery.selectMarketplaceTransferredItems();
  dateOption = inject(DATE_OPTIONS);
  private selectedItem: MartketplaceTransferredItem | null = null;
  errorCode: string = '';
  hasError: boolean = false;

  openCallbackModal(content: any, data: any): void {
    this.clearErrorMessage();
    this.selectedItem = data;
    this.modalService.open(content, { windowClass: 'wallet-callback-item-modal', centered: true, size: 'lg' });
  }

  callBack(): void {
    if (!this.selectedItem) return;
    this.clearErrorMessage();

    this.rewardsWalletService.callbackItem(this.selectedItem).subscribe({
      next: () => {
        this.modalService.dismissAll();
        this.rewardsWalletService.disableRewardsWalletStoreCache();
      },
      error: (err) => {
        if (err?.error?.Code) {
          this.errorCode = err.error.Code;
        }
        this.hasError = true;
      },
    });
  }

  private clearErrorMessage(): void {
    this.errorCode = '';
    this.hasError = false;
  }
}
